// extracted by mini-css-extract-plugin
export default {"secaoprincipal":"CadastroResponsavel_secaoprincipal__Jwdkp","cabecalho_page":"CadastroResponsavel_cabecalho_page__VkgFR"};